export default __webpack_public_path__ + "static/media/ic_mini_tempo_block.58a12e47.svg";